var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0478 0.000176235H0.952006C0.426644 0.000176235 0 0.42706 0 0.952182V23.048C0 23.5734 0.426884 24 0.952006 24H23.0478C23.5732 24 23.9998 23.5731 23.9998 23.048V0.985013C23.9998 0.45988 23.5732 0 23.0478 0V0.000176235ZM1.90413 1.93743H7.50664V22.0962H1.90413V1.93743ZM22.0957 22.0962H9.47655V1.93743H22.0957V22.0962Z",
    fill: "#0D2549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7388 12.8047L16.6458 16.7118C16.8428 16.9087 17.0727 17.0072 17.3354 17.0072C17.5981 17.0072 17.8278 16.9087 18.025 16.7118C18.4189 16.3179 18.4189 15.7268 18.025 15.3328L14.8075 12.1154L18.2219 8.70099C18.6159 8.30707 18.6159 7.71597 18.2219 7.32205C17.828 6.92813 17.2369 6.92814 16.843 7.32205L12.7388 11.4258C12.5418 11.6227 12.4434 11.8527 12.4434 12.1154C12.4434 12.3778 12.5418 12.6405 12.7388 12.8047Z",
    fill: "#0D2549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.83486b90f1e5de946b018f3ca5922ab2.svg";
export { ForwardRef as ReactComponent };